import { WebGLTile as LayerTileWebGL } from 'ol/layer';
import { OSM } from 'ol/source';
import { default as RLayerWebGL } from './RLayerWebGL';
/**
 * An OpenStreetMap layer rendered by WebGL
 *
 * Requires an `RMap` context
 */
export default class ROSMWebGL extends RLayerWebGL {
    constructor(props) {
        super(props);
        this.source = new OSM();
        this.ol = new LayerTileWebGL({
            source: this.source,
            cacheSize: props.cacheSize
        });
        this.eventSources = [this.ol, this.source];
    }
    refresh(prevProps) {
        super.refresh(prevProps);
        this.ol.setProperties({ label: 'OpenStreetMap' });
    }
}
//# sourceMappingURL=ROSMWebGL.js.map